const InfoIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' className="inline-block">
    <path
      d='M7.99992 1.33325C4.32392 1.33325 1.33325 4.32392 1.33325 7.99992C1.33325 11.6759 4.32392 14.6666 7.99992 14.6666C11.6759 14.6666 14.6666 11.6759 14.6666 7.99992C14.6666 4.32392 11.6759 1.33325 7.99992 1.33325ZM8.66658 11.3333H7.33325V7.33325H8.66658V11.3333ZM8.66658 5.99992H7.33325V4.66658H8.66658V5.99992Z'
      className="fill-[#91B1BE] dark:fill-gray-400"
    />
  </svg>
);

export default InfoIcon;
